import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { LeaseLicenseService } from '../service/leaseLicense.service';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { Router } from '@angular/router';

@Component({
  selector: 'dda-globalpaymentresponse',
  templateUrl: './globalpaymentresponse.component.html',
  styleUrls: ['./globalpaymentresponse.component.scss'],
  
})
export class GlobalpaymentresponseComponent implements OnInit {
  
  constructor(private route: ActivatedRoute,private http: HttpClient,private leaseLicenseService: LeaseLicenseService,private router : Router) { }
  payload:any;
  url:any;
  responseMessage: string;
  success:boolean=false
  status:any;
  order_id:any;
  reciept_id:any;
  module:any;
  payFor:any;

   ngOnInit() {
   this.success=false
    this.route.queryParams.subscribe(
      (params) => {
        
        if(params.status==101)
        {
          this.responseMessage="Successfull"
        }
        if(params.status==100)
        {
          this.responseMessage="Fail"
        }
         
          this.status=params.status
          this.order_id=params.order_id
          this.reciept_id=params.reciept_id
          this.module=params.moduleName
          this.payFor=params.payFor
          
       
      })

  }
  BackToapplication()
  {
    if(this.module=='Fuel Station')
    {
    
      this.router.navigate(['/fuelStation/fuelStationMyApp']);
    }
    if(this.module == 'Lease License')
    {
      if(this.payFor=== 'EMI')
      {
        this.router.navigate(['/lease-lisense/make-payment']);
      }
      else
      this.router.navigate(['/lease-lisense/myAppKyc']);
    }
    if(this.module == 'Permission Lift')
    {
      this.router.navigate(['/permission-lift/myApplication']);
    }

    if(this.module == 'Park Booking')
    {
      this.router.navigate(['/parkBooking/myBooking']);
    }

  }
  generatePdf() {
    const doc = new jspdf.jsPDF();
    const element = document.getElementById('paymentstatus');
  
    html2canvas(element).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 200;
      const pageHeight = 500;
      const imgHeight = 20//(canvas.height * imgWidth) / canvas.width;
      let position = 0;
      var options = {
        quality: 1
      };
      // doc.(0, 20, 0, 0);
      doc.addImage(imgData, 'JPEG', 1, position, imgWidth, imgHeight);
  
      doc.save(this.order_id+'.pdf');
    });
  }
    
  // call()
  // {
  //   this.payload={
  //     amount: "10000",
  //     callback_url: "http://localhost:8081/dda/leaseAndLicenseFee/getResponseMaharastra",
  //     cname: "John Doe",
  //     email: "test@test.com",
  //     key: "test_eDhhF",
  //     phone: "9808201283",
  //     receipt_id: "res141",
  //     hash:"db5465b0d926e902ba2a17dd2c0e1391a654e1a8eaaa479ab86fe29cb45abf2b27819eea80555661bf8ab4f0c88229d480e501cd5b32cee77e522091ccc098f7"
     
  //      }

    
  // }
  //   getresponse()
  // {

  //   this.leaseLicenseService.getGlobalpaymentUrl(this.payload).subscribe(data => {
  //     if(data)
  //     {
  //       const callbackUrl=this.payload.callback_url
  //       this.url=atob(data.url)
  //       window.location.href=this.url;
     
  //     }
  //   })
    
  // } 
}
